import React, {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {Checkboxes, FileInput, RadioButtons, TabPanel, Dropdown} from '../../../FlowConfigurationInputs';
import {TextInput} from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @param       showAlert -  show alert
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function ReadSheet({action, showAlert, setOpenVariable, variables}) {
    const {t} = useTranslation();
    const [value, setValue] = useState(0);
    const label = 'CONTENT.CONFIGURATION-FORM.EXCEL.READ-SHEET.';
    const options = {
        fileInput: {
            checkExtension: (ext) => {
                if (ext.toLocaleLowerCase() !== 'xls' && ext.toLocaleLowerCase() !== 'xlsx' && ext.toLocaleLowerCase() !== 'xlsm') {
                    showAlert(t(label + 'UPLOAD_EXCEL_ONLY'));
                    return false;
                }
                return true;
            },
            fileType: '.xlsm, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        },
        radioButtons: {
            data: [{
                value: 'ro',
                label: label + 'READ-ONLY'
            }, {
                value: 'rw',
                label: label + 'READ-WRITE'
            }],
            defaultValue: 'rw'
        },
        checkboxes: {label: label + 'SHEET-CONTAINS-A-HEADER'},
        dropdown: {
            data: [
                {
                    value: "dd-mm-yyyy",
                    label: "DD-MM-YYYY",
                },
                {
                    value: "mm-dd-yyyy",
                    label: "MM-DD-YYYY",
                },
                {
                    value: "yyyy-mm-dd",
                    label: "YYYY-MM-DD",
                },
                {
                    value: "dd.mm.yyyy",
                    label: "DD.MM.YYYY",
                },
                {
                    value: "mm.dd.yyyy",
                    label: "MM.DD.YYYY",
                },
                {
                    value: "yyyy.mm.dd",
                    label: "YYYY.MM.DD",
                },
                {
                    value: "dd/mm/yyyy",
                    label: "DD/MM/YYYY",
                },
                {
                    value: "mm/dd/yyyy",
                    label: "MM/DD/YYYY",
                },
                {
                    value: "yyyy/mm/dd",
                    label: "YYYY/MM/DD",
                },
            ],
            defaultValue: "yyyy.mm.dd",
        }
    }
    useEffect(() => {
        if (!action.fields.fileType) {
            action.fields.fileType = {value: "FILE"};

        } else {
            if (action.fields.fileType.value === "FILE") {
                setValue(0);
            } else {
                setValue(1)
            }
        }
    }, [action, variables])

    function handleChangeTabs(newValue) {
        if (newValue === 1) {
            action.fields.filePath.type = 'TEXT';
            action.fields.fileType.value = 'TEXT';
            action.fields.filePath.backup = {value: action.fields.filePath.value};
            action.fields.filePath.value = "";
            if (action.fields.filePath.backupText?.value) {
                action.fields.filePath.value = action.fields.filePath.backupText.value;
            }
        } else {
            action.fields.filePath.type = 'FILE';
            action.fields.fileType.value = 'FILE';

            action.fields.filePath.backupText = {value: action.fields.filePath.value}
            delete action.fields.filePath.value
            if (action.fields.filePath.backup?.value) {
                action.fields.filePath.value = action.fields.filePath.backup.value;
            }
        }
        setValue(newValue);
    }

    return (
        <div>
            <div className="form-element">
                {t(label + 'FILE-PATH')}
                <div className="condition-tabs" style={{marginBottom: 5}}>
                    <button
                        className={value === 0 ? 'condition-active' : ''}
                        onClick={() => handleChangeTabs(0)}>
                        {t(label + 'SELECT-FILE')}
                    </button>
                    <button
                        className={value === 1 ? 'condition-active' : ''}
                        onClick={() => handleChangeTabs(1)}>
                        {t(label + 'CUSTOM-STRING')}
                    </button>
                </div>
                <TabPanel value={value} index={0}>
                    <FileInput action={action} inputName="filePath" options={options.fileInput} isRequired
                               isSize={true}/>
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <TextInput action={action} inputName="filePath" isRequired={false} setOpenVariable={setOpenVariable}
                               variables={variables}/>
                </TabPanel>
            </div>
            <div className="form-element">
                {t(label + 'SHEET-NAME')}
                <TextInput action={action} inputName="sheetName" setOpenVariable={setOpenVariable}
                           variables={variables} fieldType="string" displayName={t(label + 'SHEET-NAME')}/>
            </div>
            <div className="form-element">
                {t(label + 'OPEN-AS')}
                <RadioButtons action={action} inputName="openAs" options={options.radioButtons} isRequired/>
            </div>
            <div className="form-element">
                {t(label + "DATE-FORMAT")}
                <div style={{display: "flex", justifyContent: "space-between", width: "90%"}}>
                    <Dropdown
                        action={action}
                        inputName="dateFormat"
                        options={options.dropdown}
                        isRequired={true}
                    />
                </div>
                <small><em>{t(label + 'DATE-FORMAT-COMMENT')}</em></small>
            </div>
            <div className="form-element">
                <Checkboxes action={action} inputName="headerContains" options={options.checkboxes}/>
            </div>
            <div className="form-element">
                {t(label + 'ASSIGN')}
                <VariablePicker action={action} inputName="set" variables={variables} setOpenVariable={setOpenVariable}
                                filter="data table" isRequired/>
                <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', {type: 'data table'})}</em></small>
            </div>
        </div>
    )
}

export default ReadSheet;
